import { useContext, useCallback, useState } from 'react';
import { AppContext, AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import * as dashboardModel from './model';

const useService = () => {
	const { getData, postData } = useContext(AjaxContext);
	const {
		showAlert,
		app: { appName }
	} = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);

	const getConfigList = useCallback(async () => {
		try {
			setShowLoader(true);
			const result: { data: dashboardModel.IRewardCoinsUtilResponse } = await getData({
				endpoint: '/marketing/dashboard/cashbackUtil/getCashbackUtils',
				queryParams: {
					appName
				}
			});
			if (!result?.data?.success) throw Error('Error in fetching the data!');
			return {
				rowCount: _get(result, ['data', 'count'], 0),
				data: formatListData(_get(result, ['data', 'data'], []))
			};
		} catch (error) {
			showAlert('Error in fetching the config', { type: 'error' });
			throw error;
		} finally {
			setShowLoader(false);
		}
	}, []);

	const handleDeleteSegmentData = async (submittedData: string): Promise<void> => {
		try {
			const result: { data: dashboardModel.RESPONSE } = await postData({
				endpoint: '/marketing/dashboard/cashbackUtil/deleteCashbackSegments',
				queryParams: {
					appName
				},
				body: {
					segmentName: submittedData
				}
			});
			if (!result?.data?.success) throw Error('Error in deleting the segment data!');
			return;
		} catch (error) {
			showAlert('Error in deleting the segment data', { type: 'error' });
		}
	};

	return {
		getConfigList,
		showLoader,
		handleDeleteSegmentData
	};
};

export default useService;
